export enum ToastAppType {
    Error = 1,
    Info = 2,
    Warn = 3,
    Success = 4,
}